import { render } from "./NewFeature.vue?vue&type=template&id=fe9b3042&scoped=true"
import script from "./NewFeature.vue?vue&type=script&lang=js"
export * from "./NewFeature.vue?vue&type=script&lang=js"

import "./NewFeature.vue?vue&type=style&index=0&id=fe9b3042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe9b3042"]])

export default __exports__